import React from 'react'

type Entry = {
  question?: string | null
  answer?: string | null
}

type Props = {
  entries?: Entry[] | null
  className?: string
  /** Título/aria traduzido (namespace «Blocks»). Default pt quando idiomas inativos. */
  titleText?: string
}

/**
 * FAQ semântico para AEO; dados espelhados em JSON-LD no artigo.
 */
export function FaqBlock({ entries, className, titleText = 'Perguntas frequentes' }: Props) {
  const rows =
    Array.isArray(entries)
      ? entries
          .map((e) => ({
            q: typeof e?.question === 'string' ? e.question.trim() : '',
            a: typeof e?.answer === 'string' ? e.answer.trim() : '',
          }))
          .filter((e) => e.q && e.a)
      : []

  if (!rows.length) return null

  return (
    <section
      className={['faq-block col-start-2 my-8 space-y-3', className ?? ''].filter(Boolean).join(' ')}
      data-block-type="faq"
      aria-label={titleText}
    >
      <h2 className="text-foreground m-0 text-xl font-semibold tracking-tight md:text-2xl">
        {titleText}
      </h2>
      <div className="divide-border divide-y rounded-lg border border-border/80">
        {rows.map((item, i) => (
          <details key={`${i}-${item.q.slice(0, 24)}`} className="group px-4 py-3 md:px-5">
            <summary className="text-foreground cursor-pointer list-none font-medium outline-none [&::-webkit-details-marker]:hidden">
              <span className="inline-flex w-full items-center justify-between gap-2">
                {item.q}
                <span
                  className="text-muted-foreground shrink-0 text-lg transition-transform group-open:rotate-180"
                  aria-hidden
                >
                  ▾
                </span>
              </span>
            </summary>
            <div className="text-muted-foreground mt-3 text-sm leading-relaxed whitespace-pre-wrap md:text-[0.9375rem]">
              {item.a}
            </div>
          </details>
        ))}
      </div>
    </section>
  )
}
